import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

// Get all users
export const getUsers = async () => {
    const response = await axios.get(`${API_URL}/users`, getAuthHeaders());
    return response.data;
};

// Get user by ID
export const getUser = async (userId) => {
    const response = await axios.get(`${API_URL}/users/${userId}`, getAuthHeaders());
    return response.data;
};

// Create a new user
export const createUser = async (userData) => {
    const response = await axios.post(`${API_URL}/users`, userData, getAuthHeaders());
    return response.data;
};

// Update user
export const updateUser = async (userId, userData) => {
    const response = await axios.put(`${API_URL}/users/${userId}`, userData, getAuthHeaders());
    return response.data;
};

// Delete user
export const deleteUser = async (userId) => {
    const response = await axios.delete(`${API_URL}/users/${userId}`, getAuthHeaders());
    return response.data;
};

// Get roles (for user creation/editing)
export const getRoles = async () => {
    const response = await axios.get(`${API_URL}/roles`, getAuthHeaders());
    return response.data;
};

const userService = {
    getUsers,
    getUser,
    createUser,
    updateUser,
    deleteUser,
    getRoles
};

export default userService;
